export default "__VITE_ASSET__259d641c__"